import { LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { EntityInfoActions, EntityInfoTypeActions } from "../actions";
import { EntityInfoState, initialEntityInfoState } from "../entityinfo.state";

export const entityInfosReducer = createReducer(
    initialEntityInfoState,
    on(EntityInfoActions.updateSet.request, EntityInfoActions.createSet.request, EntityInfoActions.loadSet.request, state => ({
        ...state,
        entityinfos: {
            ...state.entityinfos,
            callState: LoadingState.loading,
        },
    })),
    on(EntityInfoActions.updateSet.success, EntityInfoActions.createSet.success, (state, { entityinfo }) => ({
        ...state,
        entityinfos: {
            ...state.entityinfos,
            result: {
                ...state.entityinfos.result,
                [entityinfo.id]: entityinfo,
            },
            callState: LoadingState.loaded,
        },
    })),
    on(EntityInfoActions.clearEntityInfoState, state => ({
        ...state,
        entityinfos: initialEntityInfoState.entityinfos,
    })),

    on(EntityInfoActions.loadSet.success, (state, { entityinfos }) => ({
        ...state,
        entityinfos: {
            result: entityinfos,
            callState: LoadingState.loaded,
        },
    })),

    on(EntityInfoTypeActions.loadSet.success, (state, { entityinfotypes }) => ({
        ...state,
        entityinfoTypes: {
            result: entityinfotypes,
            callState: LoadingState.loaded,
        },
    })),

    on(EntityInfoActions.silentDeleteSet.success, EntityInfoActions.deleteSet.success, (state, { entityinfo }): EntityInfoState => {
        const entityinfos = state.entityinfos.result;
        delete entityinfos[entityinfo.id];
        return {
            ...state,
            entityinfos: {
                result: entityinfos,
                callState: LoadingState.loaded,
            },
        };
    })
);
